import React, { useEffect, useState } from "react";
import styles from "../UploadImageQR.module.scss";
import { LoadingComponent } from "../../loadingComponent/LoadingComponent.jsx";
import { serviceHasError, serviceIsLoadingOrFetched, serviceIsSuccessfullyFetched } from "./../../../service/seviceUtils.js";
import { CustomImageNew } from "../../../image/CustomImage.jsx";
import CloseIcon from "return-portal/src/icons/CloseIcon.js";
import useServiceHook from "../../../service/useServiceHook.js";
import { COLORS } from "../../../constants.js";

function UploadedImageBox(props) {
    const { multipleImageQrProps, selectedImage } = props;
    const { onRemoveClick } = multipleImageQrProps;
    const { imageBlobFile, id } = selectedImage ?? {};

    const [imageBlobFileUrl] = useState(URL.createObjectURL(imageBlobFile));

    return (
        <div
            style={{
                position: "relative",
                width: "70px",
                height: "70px",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
            }}
        >
            <CustomImageNew data-test-id={"complaint-image-uploaded"} className={styles["image"]} fill style={{ objectFit: "cover" }} src={imageBlobFileUrl} alt="Uploaded image" />
            <div
                style={{
                    position: "absolute",
                    cursor: "pointer",
                    padding: "5px",
                    top: "-8px",
                    right: "-8px",
                    borderRadius: "30px",
                    background: "#f4f6f8",
                }}
                onClick={() => {
                    onRemoveClick(id);
                }}
            >
                <CloseIcon style={{ display: "block" }} width={8} height={8} />
            </div>
        </div>
    );
}

function UploadingImageBox(props) {
    const { appProps, multipleImageQrProps, selectedImageDataLocally } = props;
    const { onRemoveImageDataLocally, alertFn, imageUrlServiceFetchData, imageUrlServiceFn, onUploadSuccess } = multipleImageQrProps;
    const { file, id } = selectedImageDataLocally ?? {};

    const { serviceData: imageUrlsServiceData } = useServiceHook({
        appProps,
        fetchRequested: true,
        fetchFn: imageUrlServiceFn,
        fetchData: imageUrlServiceFetchData,
    });

    const { serviceData: imageUploadUrlServiceData, fetchServiceData: fetchImageUploadUrl } = useServiceHook({
        appProps,
        fetchRequested: false,
        fetchFn: (system, { file, uploadUrl }) => {
            return (system?.fetch || fetch)(uploadUrl, {
                method: "PUT",
                headers: {},
                body: file,
            });
        },
    });

    useEffect(() => {
        if (file && serviceIsSuccessfullyFetched(imageUrlsServiceData) && !serviceIsLoadingOrFetched(imageUploadUrlServiceData)) {
            fetchImageUploadUrl({
                file,
                uploadUrl: imageUrlsServiceData?.data?.image?.uploadURL,
            });
        }
    }, [file, imageUrlsServiceData, imageUploadUrlServiceData]);

    useEffect(() => {
        if (serviceIsSuccessfullyFetched(imageUploadUrlServiceData)) {
            onUploadSuccess(selectedImageDataLocally);
        }
    }, [imageUploadUrlServiceData, file]);

    useEffect(() => {
        if (serviceHasError(imageUrlsServiceData)) {
            alertFn?.({ text: "Prepare for image upload failed" });
            onRemoveImageDataLocally(selectedImageDataLocally);
        }

        if (serviceHasError(imageUploadUrlServiceData)) {
            alertFn?.({ text: "Failed to upload image" });
            onRemoveImageDataLocally(selectedImageDataLocally);
        }
    }, [imageUrlsServiceData, imageUploadUrlServiceData, id, onRemoveImageDataLocally]);

    return (
        <div
            style={{
                position: "relative",
                width: "70px",
                height: "70px",
                outline: "1px dashed " + COLORS.GRAY,
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
            }}
        >
            <LoadingComponent center />
        </div>
    );
}

function EmptyImageBox() {
    return (
        <div
            style={{
                position: "relative",
                width: "70px",
                height: "70px",
                outline: "1px dashed " + COLORS.GRAY,
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
            }}
        />
    );
}

export default function UploadMultipleImageBoxes({ appProps, multipleImageQrProps }) {
    const { selectedImages, selectedImagesDataLocally } = multipleImageQrProps;
    return (
        <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
            {selectedImages?.map((selectedImage) => {
                const { id } = selectedImage;

                return <UploadedImageBox key={id} appProps={appProps} multipleImageQrProps={multipleImageQrProps} selectedImage={selectedImage} />;
            })}
            {selectedImagesDataLocally?.map((selectedImageDataLocally) => {
                const { id } = selectedImageDataLocally;

                return <UploadingImageBox key={id} appProps={appProps} multipleImageQrProps={multipleImageQrProps} selectedImageDataLocally={selectedImageDataLocally} />;
            })}
            {selectedImages?.length + selectedImagesDataLocally?.length < 5 && <EmptyImageBox />}
        </div>
    );
}
